var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-frame',{attrs:{"sub-title":_vm.displayItem.title,"sub-content":_vm.displayItem.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }